import Vue from "vue";

const Bus = new Vue({
  name: "EventBus"
});

export default Bus;
